import { render } from "./TheCookiesMsg.pug?vue&type=template&id=16bf3742&lang=pug"
import script from "./TheCookiesMsg.js?vue&type=script&lang=js"
export * from "./TheCookiesMsg.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__